import * as React from 'react';
import './fonts';
import { BodyWidget } from './widgets-smart/BodyWidget';
import { BrowserRouter } from 'react-router-dom';
import { System, SystemContext } from './System';
import { ENV } from './env';
import { isMobile } from './utils/device';
import { Environments } from './utils/environments';
import { createRoot } from 'react-dom/client';
import { configure } from 'mobx';
import { hackSetupInviteNotifications } from './stores/hacks/hackSetupInviteNotifications';
import { isJourneyEmail } from '@journeyapps-platform/types-accounts';

configure({
  enforceActions: 'never'
});

declare global {
  interface Window {
    grecaptcha: any;
    ga: any;
    gtag: any;
  }
}

const loadApp = () => {
  const system = new System({
    ...ENV,
    recaptcha: {
      v2_site_key: ENV.RECAPTCHA_V2_SITE_KEY,
      v3_site_key: ENV.RECAPTCHA_V3_SITE_KEY
    },
    DEV: ENV.ENVIRONMENT === 'development',
    environment: ENV.ENVIRONMENT as Environments,
    isMobile: isMobile(),
    isJourneyUser: isJourneyEmail(ENV.USER_EMAIL || '')
  });
  const root = createRoot(document.querySelector('#application')!);
  root.render(
    <SystemContext.Provider value={system}>
      <BrowserRouter basename="/portal">
        <BodyWidget />
      </BrowserRouter>
    </SystemContext.Provider>
  );

  // HACKS
  hackSetupInviteNotifications(system);
};

if (document.readyState !== 'loading') {
  loadApp();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    loadApp();
  });
}
